import React from "react";
import {Col} from "../../components/grid";
import PageHero from "../../components/PageHero";
import FindCareer from "../../assets/homepage/tiles/find-my-career-tool.jpg";
import FindCareer2 from "../../assets/homepage/tiles/student-finding-a-career.jpg";
import Money from "../../assets/homepage/tiles/student-money-help.jpg";
import OpenDays from "../../assets/homepage/tiles/university-open-days.jpg";
import Adj from "../../assets/homepage/tiles/university-adjustment-factors.jpg";
import Eas from "../../assets/homepage/tiles/university-early-access-scheme.jpg";
import Def from "../../assets/homepage/tiles/university-deferment.jpg";
import Exch from "../../assets/homepage/tiles/university-overseas-exchange.jpg";
import Accommodation from "../../assets/homepage/tiles/university-accommodation.jpg";
import Interstate from "../../assets/homepage/tiles/university-interstate-and-overseas.jpg";
import CardGrid from "../../components/CardGrid";
import ImageCard from "../../components/cards/ImageCard";
import { openLinkInNewTab } from "../../util";
import PageSectionRow from "../../components/PageSectionRow";
import ContentWrapper from "../../components/ContentWrapper";

const images : string[] = [
    FindCareer, FindCareer2, Money, OpenDays, Adj, Eas, Def, Exch, Accommodation, Interstate
]

const links : {name:string, to:string}[] = [
    {to:"https://afs.org.au/start-here", name:"AFS Australia"},
    {to:"https://weareworldchallenge.com/australasia/antipodeans/", name:"Antipodeans Abroad"},
    {to:"https://www.aifs.com.au/programs/au-pair-in-america", name:"Au Pair in America"},
    {to:"https://www.campamerica.com.au/", name:"Camp America"},
    {to:"https://www.ccusa.com/", name:"Camp Counselors USA"},
    {to:"https://www.ef-australia.com.au/pg/", name:"EF"},
    {to:"https://www.interexchange.org/", name:"International Student Volunteers Inc."},
    {to:"https://www.kidsgivingback.org/", name:"Kids Giving Back"},
    {to:"https://letzlive.org/", name:"Letz Live"},
    {to:"https://www.projects-abroad.com.au/", name:"Projects Abroad"},
    {to:"https://raleighinternational.org/", name:"Raleigh International"},
    {to:"https://www.thisisscce.com/", name:"Southern Cross Cultural Exchange"},
    {to:"https://www.studentexchange.org.au/", name:"Student Exchange Australia"},
    {to:"https://www.studentplacement.com.au/", name:"Student Placement Australia"},
    {to:"https://www.year13.net/", name:"Year 13 Youthworks Gap Year"},
    {to:"https://www.youngendeavour.gov.au/", name:"Young Endeavour"},
    {to:"https://www.yfu.com.au/", name:"Youth for Understanding International Exchange"},
]

const GapYear : React.FC<{}> =
    () =>
        <ContentWrapper title="Gap Year"
            subtitle={["Ever considered taking a gap year or going as an exchange student? Check out the links below."]} >
            <PageSectionRow>
                <Col>
                    <CardGrid numPerRow={3} prefix="gap">
                        {links.map((l, i) =>
                            <ImageCard
                                key={`gap-tile-${i}`}
                                text={l.name}
                                onClick={()=>openLinkInNewTab(l.to)}
                                imageUrl={images[i % images.length]} />
                        )}
                    </CardGrid>
                </Col>
            </PageSectionRow>
        </ContentWrapper>

export default GapYear;